import React from 'react'

export default function IconOneTwoCol({ colour = 'currentColor', ...rest }) {
    return (
        <svg
            preserveAspectRatio='none'
            width='264'
            height='24'
            viewBox='0 0 264 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...rest}
        >
            <path
                d='M12 0.5H81.3301C83.263 0.500041 84.8301 2.06703 84.8301 4V20C84.8301 21.933 83.263 23.5 81.3301 23.5H12C10.067 23.5 8.5 21.933 8.5 20V4C8.5 2.067 10.067 0.5 12 0.5Z'
                fill='#EEEEED'
            />
            <path
                d='M12 0.5H81.3301C83.263 0.500041 84.8301 2.06703 84.8301 4V20C84.8301 21.933 83.263 23.5 81.3301 23.5H12C10.067 23.5 8.5 21.933 8.5 20V4C8.5 2.067 10.067 0.5 12 0.5Z'
                stroke='#E1E1E0'
            />
            <path
                d='M97.3301 0.5H252C253.933 0.5 255.5 2.067 255.5 4V20C255.5 21.933 253.933 23.5 252 23.5H97.3301C95.3971 23.5 93.8301 21.933 93.8301 20V4C93.8301 2.067 95.3971 0.5 97.3301 0.5Z'
                fill='#EEEEED'
            />
            <path
                d='M97.3301 0.5H252C253.933 0.5 255.5 2.067 255.5 4V20C255.5 21.933 253.933 23.5 252 23.5H97.3301C95.3971 23.5 93.8301 21.933 93.8301 20V4C93.8301 2.067 95.3971 0.5 97.3301 0.5Z'
                stroke='#E1E1E0'
            />
        </svg>
    )
}
